'use strict';

/**
 * The Auth module contains methods used to ensure the user is authenticated and able to access
 * the requested route. It also routes the user to the correct pages if the user is not authorized
 */

var auth = angular.module('common.auth', [
  'common.identity',
  'common.utils',
  'app.resources',
  'saturn.auth',
]);

var AuthConfig = require('./AuthConfig');
var AuthService = require('./AuthService');

auth.config(['sbAuthProvider',
  AuthConfig
]);

auth.run(['AuthService', function (AuthService) {
  AuthService.init();
}]);

// ## Services

auth.service('AuthService', AuthService);



// WEBPACK FOOTER //
// ./src/common/auth/index.js